<ion-content class="modal-border">
  <ion-header>
    <ion-toolbar> </ion-toolbar>
  </ion-header>

  <div class="ion-padding">
    <div *ngIf="loadingDone == false">
      <ion-label>Loading in progress, please wait...</ion-label>
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </div>

    <div *ngIf="loadingDone == true">
      <ion-button (click)="addPicture()">Add Picture</ion-button>
      <div *ngIf="Question.data.QuestionContent_GUID != null">
        <img
          style="height: 250px; width: 300px; margin-left: 100px"
          src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' +Question.data.QuestionContent_GUID + '.jpg'}}"
          (error)="globals.onThumbnailError($event,'blank.jpg')"
        />
      </div>

      <ion-grid>
        <ion-row>
          <ion-col>
            <div
              style="
                font-weight: bold;
                font-size: 25px;
                margin-top: 5px;
                margin-left: 100px;
                display: inline-block;
              "
            >
              <img
                [src]="diceImage"
                style="
                  width: 60px;
                  height: 70px;
                  padding-bottom: 0px;
                  display: inline-block;
                "
              />
            </div>

            <ion-input
              style="
                padding-left: 10% !important;
                width: 80%;
                font-weight: bold;
                font-size: 20px;
              "
              value="{{Question.data.text}}"
              [(ngModel)]="Question.data.text"
              (click)="onQuestionClick()"
            >
            </ion-input>
            <br />
          </ion-col>
        </ion-row>
        <div *ngFor="let answer of Question.data.answers;">
          <ion-row>
            <p></p>
            <br />
            <ion-col
              size="0.5"
              [ngStyle]="{'border-color':answer.isCorrect == true ? 'white':'black' }"
            >
              <img
                src="assets/img/buttons/tick.png"
                style="height: 40px; padding-top: 15px"
                [ngClass]="{'selected': answer.isCorrect == true}"
                (click)="answer.isCorrect = !answer.isCorrect; changeDice();"
              />
            </ion-col>
            <ion-col
              size="0.5"
              [ngStyle]="{'border-color':answer.isCorrect == false ? 'white':'black' }"
            >
              <img
                src="assets/img/buttons/cross.png"
                style="height: 40px; padding-top: 15px"
                [ngClass]="{'selected': answer.isCorrect == false}"
                (click)="answer.isCorrect = !answer.isCorrect; changeDice();"
              />
            </ion-col>
            <!-- <ion-col size="2" style="padding-right:0px;">
          <div *ngIf=isSelected(answer)>
            <img src='assets/img/buttons/selected.png' style="height:40px; padding-left:100px;padding-top:15px;"/>
          </div>
        </ion-col> -->

            <ion-col
              size="8"
              style="
                border-width: 2px;
                background-color: black;
                border-style: solid;
                padding: 1px;
                margin-top: 2px;
                cursor: pointer;
              "
              [ngStyle]="{'border-color':isSelected(answer) == true || isHovering(answer) == true? '#5598ff' : 'white' }"
              (mouseover)="mouseOver(answer)"
              (mouseout)="mouseOut(answer)"
              (click)="selectAnswer(answer)"
            >
              <div *ngIf="isHovering(answer)">
                <ion-input
                  style="
                    font-size: 18px;
                    font-weight: bold;
                    width: 80%;
                    padding-top: 2px;
                    padding-bottom: 2px;
                  "
                  [(ngModel)]="answer.text"
                  [ngStyle]="{'font-weight':isSelected(answer) == true ? 'bold' : 'normal'}"
                >
                </ion-input
                ><br />
              </div>

              <div *ngIf="!isHovering(answer)">
                <ion-input
                  style="
                    font-size: 18px;
                    width: 80%;
                    padding-top: 2px;
                    padding-bottom: 2px;
                  "
                  [(ngModel)]="answer.text"
                  [ngStyle]="{'font-weight':isSelected(answer) == true ? 'bold' : 'normal'}"
                ></ion-input
                ><br />
              </div>
            </ion-col>
            <ion-col size="2" style="padding-right: 0px">
              <ion-button (click)="removeAnswer(answer)">
                <ion-icon name="remove"></ion-icon>
              </ion-button>
            </ion-col>
          </ion-row>
        </div>

        <ion-row>
          <ion-col>
            <div *ngIf="Question.data.answers.length < 9">
              <ion-button (click)="addNewAnswer()">Add Answer</ion-button>
            </div>
            <!-- <div *ngIf="Question.data.answers.length == 9">
            <ion-label>Only a maximum of 9 </ion-label>
          </div> -->
          </ion-col>
        </ion-row>
        <br /><br /><br />
        <ion-row>
          <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
            <ion-button
              (click)="onClose()"
              class="menuitem-ion-button"
              style="width: 110% !important; left: 0"
              >Continue</ion-button
            >
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
</ion-content>
